import React, { FC } from 'react';
import type { TrackingActions } from './TrackingActions';

export const TrackingContext = React.createContext<TrackingActions | null>(null);

export const TrackingProvider: React.FC<{ children: React.ReactNode } & Partial<TrackingActions>> = ({
  children,
  onReadMoreClick = () => {},
  onSectionVisible = () => {},
  onViewAllClick = () => {},
}) => {
  return (
    <TrackingContext.Provider value={{ onSectionVisible, onViewAllClick, onReadMoreClick }}>
      {children}
    </TrackingContext.Provider>
  );
};

export const useTrackingActions = () => {
  let context = React.useContext(TrackingContext);

  if (!context) {
    console.warn('useTrackingActions must be used within a TrackingProvider');
    context = {
      onSectionVisible: () => {},
      onReadMoreClick: () => {},
      onViewAllClick: () => {},
    };
  }

  return context;
};
